/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import Reviews from "./Reviews";

const ReviewsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: "reviews",
      element: <Reviews />,
    },
  ],
};

export default ReviewsConfig;
